import { useState } from 'react';
import { Settings, X } from 'lucide-react';
import { toast } from 'sonner';

export const VisibilityModal = ({ api, visibility, onClose, onSaved }) => {
  const [v, setV] = useState({ ...visibility });
  const labels = {
    estimate: 'Project Estimate', labor: 'Actual Labor', materials: 'Actual Materials', equipment: 'Equipment',
    change_orders: 'Change Orders', overhead: 'Overhead Tracker', burden_rate: 'Burden Rate', profit: 'Profit Dashboard', invoices: 'Invoices'
  };
  const save = async () => {
    try { const r = await api.post('/accounting/fos/visibility', v); onSaved(r.data); toast.success('Walter access updated'); }
    catch { toast.error('Failed'); }
  };
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="visibility-modal">
      <div className="bg-white rounded-xl p-6 w-full max-w-md">
        <div className="flex items-center justify-between mb-2">
          <h3 className="font-semibold text-gray-900 flex items-center gap-2"><Settings className="w-5 h-5" /> Walter Read-Only Access</h3>
          <button onClick={onClose} data-testid="vis-modal-close"><X className="w-5 h-5 text-gray-400" /></button>
        </div>
        <p className="text-sm text-gray-500 mb-4">Toggle which Financial OS sections Walter (President) can view. He cannot edit.</p>
        <div className="space-y-2">
          {Object.keys(labels).map(k => (
            <label key={k} className="flex items-center justify-between py-2 px-3 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50">
              <span className="text-sm text-gray-700">{labels[k]}</span>
              <input data-testid={`vis-toggle-${k}`} type="checkbox" checked={!!v[k]} onChange={(e) => setV({ ...v, [k]: e.target.checked })} className="w-4 h-4 accent-[#C6A87C]" />
            </label>
          ))}
        </div>
        <button data-testid="vis-save-btn" onClick={save} className="w-full mt-5 py-2 bg-[#0A0A0A] text-white font-medium rounded-lg hover:bg-gray-800">Save Access</button>
      </div>
    </div>
  );
};
